import React, { useEffect, useState } from 'react'
import Header from './layout/Header'
import Footer from './layout/Footer'
import contact_image_2 from './contact_image_2.jpg'
import { Link } from 'react-router-dom'
import * as websiteService from './services/website.services'
import * as globalSettingService from '../admin/services/globalsetting.services'
import Swal from 'sweetalert2'
import { SWAL_SETTINGS } from '../../utils/Constants'
import { handleServerValidations } from '../../utils/commonfunction'

function ContactUs() {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phoneNumber:'',
        subject: '',
        message: ''
    });
    const [errors, setErrors] = useState({});
    const [touched, setTouched] = useState({});
    const [loading, setLoading] = useState(false);
    const [globalSettings, setGlobalSettings] = useState(null);

    useEffect(() => {
        globalSettingService.Details().then(response => {
            if (response.success) {
                setGlobalSettings(response.data);
            }
        });
    }, []);

    const validateField = (name, value) => {
        let error = '';
        if (name === 'name') {
            if (!value || !value.trim()) {
                error = 'Name is required';
            } else if (value.trim().length < 2) {
                error = 'Name must be at least 2 characters';
            } else if (value.trim().length > 50) {
                error = 'Name cannot exceed 50 characters';
            }
        } else if (name === 'email') {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!value) {
                error = 'Email is required';
            } else if (!emailRegex.test(value)) {
                error = 'Please enter a valid email address';
            }
        } else if (name === 'phoneNumber') {
            if (value && value.trim()) {
                const phoneRegex = /^\+?[0-9\s\-()]{7,15}$/;
                if (!phoneRegex.test(value)) {
                    error = 'Please enter a valid phone number';
                }
            }
        } else if (name === 'subject') {
            if (!value || !value.trim()) {
                error = 'Subject is required';
            } else if (value.trim().length < 3) {
                error = 'Subject must be at least 3 characters';
            } else if (value.trim().length > 100) {
                error = 'Subject cannot exceed 100 characters';
            }
        } else if (name === 'message') {
            if (!value || !value.trim()) {
                error = 'Message is required';
            } else if (value.trim().length < 10) {
                error = 'Message must be at least 10 characters';
            } else if (value.trim().length > 1000) {
                error = 'Message cannot exceed 1000 characters';
            }
        }
        return error;
    };

    const validateForm = () => {
        let tempErrors = {};
        Object.keys(formData).forEach(key => {
            const error = validateField(key, formData[key]);
            if (error) {
                tempErrors[key] = error;
            }
        });
        setErrors(tempErrors);
        return Object.keys(tempErrors).length === 0;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
        if (errors[name]) {
            setErrors(prev => ({ ...prev, [name]: '' }));
        }
    };

    const handleBlur = (e) => {
        const { name, value } = e.target;
        setTouched(prev => ({ ...prev, [name]: true }));
        const error = validateField(name, value);
        setErrors(prev => ({ ...prev, [name]: error }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        // Mark all fields as touched
        setTouched({
            name: true,
            email: true,
            phoneNumber: true,
            subject: true,
            message: true
        });

        const isValid = validateForm();
        if (!isValid) return;

        setLoading(true);
        try {
            const payload = {
                name: formData.name.trim(),
                email: formData.email.trim(),
                phoneNumber: formData.phoneNumber.trim(),
                subject: formData.subject.trim(),
                message: formData.message.trim()
            };
            const response = await websiteService.ContactUs(payload);
            if (response.success) {
                Swal.fire({
                    icon: 'success',
                    text: 'Query sent successfully, our team will get back to you soon',
                    ...SWAL_SETTINGS
                });
                setFormData({ name: '', email: '', phoneNumber: '', subject: '', message: '' });
                setErrors({});
                setTouched({});
            }
        } catch (error) {
            Swal.fire({
                icon: 'error',
                text: handleServerValidations(error),
                ...SWAL_SETTINGS
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <React.Fragment>
            <Header />
            <main>
                <section className='contact_us_banner'>
                     <div className='container'>
                         <h1 className='faq-title text-center text-white'>Contact Us</h1>
                     </div>
                </section>

                <section className='contact_us'>
                     <div className='container'>
                         <div className='contact_grid'>
                             <div className='contact_grid_item_left'>
                                 <form className='contact_form_wrap' onSubmit={handleSubmit} noValidate>
                                     <div className='contact_form_head'>
                                         <h2 className='contact_grid_item_title mb-0'>Get in touch</h2>
                                         <p className='contact_grid_item_text mb-0'>
                                             Connect with our team and we will get back to you.
                                         </p>
                                     </div>

                                     <div className='contact_form_fields'>
                                         <div className='mb-3'>
                                             <label className='contact_form_label form-label'>Name</label>
                                             <input 
                                                 type='text' 
                                                 name='name'
                                                 className={`form-control contact_form_input ${touched.name && errors.name ? 'is-invalid' : ''}`}
                                                 placeholder='Enter name' 
                                                 value={formData.name}
                                                 onChange={handleChange}
                                                 onBlur={handleBlur}
                                             />
                                             {touched.name && errors.name && (
                                                 <div className='invalid-feedback d-block text-start'>
                                                     {errors.name}
                                                 </div>
                                             )}
                                         </div>

                                         <div className='mb-3'>
                                             <label className='contact_form_label form-label'>Email</label>
                                             <input 
                                                 type='email' 
                                                 name='email'
                                                 className={`form-control contact_form_input ${touched.email && errors.email ? 'is-invalid' : ''}`}
                                                 placeholder='Enter email' 
                                                 value={formData.email}
                                                 onChange={handleChange}
                                                 onBlur={handleBlur}
                                             />
                                             {touched.email && errors.email && (
                                                 <div className='invalid-feedback d-block text-start'>
                                                     {errors.email}
                                                 </div>
                                             )}
                                         </div>
                                         
                                          <div className='mb-3'>
                                              <label className='contact_form_label form-label'>Mobile Number <span className="text-black ">(optional)</span></label>
                                              <input 
                                                  type='text' 
                                                  name='phoneNumber'
                                                  className={`form-control contact_form_input ${touched.phoneNumber && errors.phoneNumber ? 'is-invalid' : ''}`}
                                                  placeholder='Enter mobile number' 
                                                  value={formData.phoneNumber}
                                                  onChange={handleChange}
                                                  onBlur={handleBlur}
                                              />
                                              {touched.phoneNumber && errors.phoneNumber && (
                                                  <div className='invalid-feedback d-block text-start'>
                                                      {errors.phoneNumber}
                                                  </div>
                                              )}
                                          </div>

                                         <div className='mb-3'>
                                             <label className='contact_form_label form-label'>Subject</label>
                                             <input 
                                                 type='text' 
                                                 name='subject'
                                                 className={`form-control contact_form_input ${touched.subject && errors.subject ? 'is-invalid' : ''}`}
                                                 placeholder='Enter subject' 
                                                 value={formData.subject}
                                                 onChange={handleChange}
                                                 onBlur={handleBlur}
                                             />
                                             {touched.subject && errors.subject && (
                                                 <div className='invalid-feedback d-block text-start'>
                                                     {errors.subject}
                                                 </div>
                                             )}
                                         </div>

                                         <div className='mb-0'>
                                             <label className='contact_form_label form-label'>Message</label>
                                             <textarea 
                                                 name='message'
                                                 className={`form-control contact_form_textarea ${touched.message && errors.message ? 'is-invalid' : ''}`}
                                                 rows='5' 
                                                 placeholder='Write' 
                                                 value={formData.message}
                                                 onChange={handleChange}
                                                 onBlur={handleBlur}
                                             />
                                             {touched.message && errors.message && (
                                                 <div className='invalid-feedback d-block text-start'>
                                                     {errors.message}
                                                 </div>
                                             )}
                                         </div>
                                     </div>

                                    <div className='contact_form_footer'>
                                        <button type='submit' className='btn btn-secondary' disabled={loading}>
                                            {loading ? 'Sending...' : 'Send'}
                                        </button>

                                        <div className='contact_email_row d-flex align-items-center'>
                                            <span className='contact_email_icon' aria-hidden='true'>
                                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M17.5 5.83329C17.5 5.39127 17.3244 4.96734 17.0118 4.65478C16.6993 4.34222 16.2754 4.16663 15.8333 4.16663H4.16667C3.72464 4.16663 3.30072 4.34222 2.98816 4.65478C2.6756 4.96734 2.5 5.39127 2.5 5.83329V14.1666C2.5 14.6087 2.6756 15.0326 2.98816 15.3451C3.30072 15.6577 3.72464 15.8333 4.16667 15.8333H15.8333C16.2754 15.8333 16.6993 15.6577 17.0118 15.3451C17.3244 15.0326 17.5 14.6087 17.5 14.1666V5.83329Z" stroke="#001D3D" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M17.5 5.83337L10 10.8334L2.5 5.83337" stroke="#001D3D" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                            </span>
                                            <span className='contact_email_text'>Email us on <Link to={`mailto:${globalSettings?.support_email || 'admin@mnetrics.com'}`}>{globalSettings?.support_email || 'admin@mnetrics.com'}</Link> </span>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div className='contact_grid_item_right'>
                                <img src={contact_image_2} alt='Contact Us Image' />
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
        </React.Fragment>
    )
}

export default ContactUs